import { useTranslation } from 'react-i18next'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import type { ButtonProps } from './types'
import './Button.css'

/** Botón del sistema Huésped (DESIGN.md §4). Siempre con etiqueta; crece en alto, nunca trunca. */
export function Button({
  variant = 'primary',
  icon,
  children,
  fullWidth = true,
  size = 'default',
  loading = false,
  disabled = false,
  type = 'button',
  className,
  ...rest
}: ButtonProps) {
  const { t } = useTranslation()
  const off = disabled || loading
  const iconSize = size === 'large' ? 32 : 20
  return (
    <button
      type={type}
      disabled={off}
      aria-busy={loading || undefined}
      aria-disabled={off || undefined}
      className={cx(
        'hp-button',
        `hp-button--${variant}`,
        size === 'large' && 'hp-button--large',
        fullWidth && 'hp-button--full',
        loading && 'hp-button--loading',
        className,
      )}
      {...rest}
    >
      {loading ? <Icon name="loader" size={iconSize} spin /> : icon ? <Icon name={icon} size={iconSize} /> : null}
      <span className="hp-button__label">{loading ? t('v2.comun.unMomento') : children}</span>
    </button>
  )
}
